import { Alert, Button, Col, Form, Input, message, Row, Switch } from 'antd'
import Email from '../../../api/Email'
import Templates from '../../../api/Templates'
import EmailCont from '../../../components/Common/Email/EmailCont'
import withSort from '../../../elements/HOC/withSort'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import useModalShow from '../../../elements/Hooks/useModalShow'
import useSubmit from '../../../elements/Hooks/useSubmit'
import IconText from '../../../elements/IconText'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'
import CustomTable from '../../../elements/Table/CustomTable'
import { defaultFormItemLayout } from '../../../modules/FormItems'
import { idMaker } from '../../../modules/Utils'
import React, { Fragment, useState } from 'react'
import { get, isEmpty, pick } from 'lodash'
import { compose } from 'recompose'
import InfoText from '../../../elements/InfoText'
import RefreshButton from '../../../elements/Buttons/RefreshButton'

const templateApi = new Templates()
const emailApi = new Email()
const ids = idMaker()

function Folders(props) {
  const { enquiry } = props
  const activities = get(enquiry, '_id')

  const url = `https://files.mondiale.com/api/${activities}/folders`
  const { data: folderList, fetching, fetchURL } = useFetchURL(url, [activities], isEmpty(activities))
  const [isNewFolder, setIsNewFolder] = useState(false)
  const [selectedFolder, setSelectedFolder] = useState()
  const [selectedFile, setSelectedFile] = useState()
  const [newFolder, setNewFolder] = useState('')

  const filesURL = `https://files.mondiale.com/api/${selectedFolder}/files`
  const { data: files, fetching: fetchingFiles, fetchURL: fetchFile } = useFetchURL(
    filesURL,
    [selectedFolder],
    isEmpty(selectedFolder),
  )

  const activitiesFilesURL = `https://files.mondiale.com/api/${activities}/files`
  const { data: activitiesFiles, fetching: fetchingActivitiesFiles, fetchURL: fetchActivitiesFile } = useFetchURL(
    activitiesFilesURL,
    [activities],
    isEmpty(activities),
  )

  const FolderSelect = compose(withData({ data: folderList }), withSort)(CustomSelect)

  const FilesSelect = compose(withData({ data: activitiesFiles }), withSort)(CustomSelect)

  const [_3, submitTemplate] = useSubmit(templateApi.read, true)
  const [_1, submitTranTemplate] = useSubmit(emailApi.tranTemplate, true)
  // const [_2, submitTranFiles] = useSubmit(MRNApi.files, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    let hide = message.loading('Fetching Email Template ...', 0)

    const company = get(enquiry, 'company._id', '').replace('members/', '')
    const tranTemplate = await submitTemplate(company, 'transmittal')
    const emailDetails = get(tranTemplate, 'email') || {}
    const data = await submitTranTemplate({
      receiver: get(enquiry, 'enquirer_rep.fn'),
      companyRep: get(enquiry, 'sales_rep.fn'),
      company: get(enquiry, 'company.fn'),
      code: get(enquiry, 'code'),
      refNo: get(enquiry, 'reference.no'),
      tranLink: `https://files.mondiale.com/#${selectedFolder.replace('folders/', '')}`,
      ...emailDetails,
    })

    setEmailFiles(files)
    const filesMapped = files.map((f) => f.uuid || f.uid )
    setEmailTemplate(data.html)
    setEmailDetails({
      to: get(enquiry, 'enquirer_rep.email.label'),
      cc: get(enquiry, 'sales_rep.email.label'),
      bcc: get(emailDetails, 'bcc'),
      from: get(emailDetails, 'from'),
      subject: `[${get(enquiry, 'code')}] ${get(enquiry, 'title')}`,
      attachments: filesMapped,
    })

    hide()
  })

  async function submitFolder() {
    const newFolderData = {
      mac: pick(props.enquiry, ['_id', '_key', 'code']),
      name: newFolder,
    }

    try {
      await fetch(`https://files.mondiale.com/api/folders`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(newFolderData),
      })
      fetchURL()
      setIsNewFolder(false)
      setSelectedFolder(null)
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || 'Can\'t Create Folder !')
    }
  }

  async function onAssign() {
    const linkData = {
      file: activitiesFiles.find((i) => i._id === selectedFile),
      folder: folderList.find((i) => i._id === selectedFolder),
    }
    try {
      await fetch(`https://files.mondiale.com/api/link`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(linkData),
      })
      fetchFile()
      fetchActivitiesFile()
      setSelectedFile(null)
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || 'Can\'t Assign File !')
    }
  }

  async function removeFolder(id) {
    const newFolderData = {
      _id: id,
    }
    try {
      await fetch(`https://files.mondiale.com/api/folders`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
        body: JSON.stringify(newFolderData),
      })
      fetchURL()
      setIsNewFolder(false)
      setSelectedFolder(null)
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || 'Can\'t Remove Folder !')
    }
  }

  async function removeLink(id) {
    const newFolderData = {
      rid: id,
    }
    try {
      await fetch(`https://files.mondiale.com/api/link`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
        body: JSON.stringify(newFolderData),
      })
      fetchURL()
      setIsNewFolder(false)
      setSelectedFolder(null)
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || 'Can\'t Remove Link !')
    }
  }

  return (
    <Fragment>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
      />
      <InfoText text={'You can create new folder or select a folder and assign files'} />
      <Button onClick={onShowEmail} disabled={!selectedFolder}>
        <IconText text={'Send Email'} type={'mail'} />
      </Button>
      <Row style={{ marginTop: 10 }}>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label='New Folder'>
            <Switch onChange={(checked) => setIsNewFolder(checked)} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {!isNewFolder && (
          <Fragment>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label='Folder'>
                <FolderSelect
                  keyAtr={'_id'}
                  valueAtr={'name'}
                  placeholder='Select a Folder'
                  style={{ width: '100%' }}
                  value={selectedFolder}
                  onChange={(c) => setSelectedFolder(c)}
                />
              </Form.Item>
            </Col>
            {selectedFolder && (
              <>
                <Col span={3}>
                  <Button
                    type={'danger'}
                    style={{ marginLeft: '10px' }}
                    disabled={isNewFolder}
                    onClick={() => removeFolder(selectedFolder)}>
                    Remove
                  </Button>
                </Col>
                <Col span={8}>
                  <Form.Item {...defaultFormItemLayout} label='Folders Link'>
                    <a target={'_blank'} href={`https://files.mondiale.com/#${selectedFolder.replace('folders/', '')}`}>
                      https://files.mondiale.com/#
                      {selectedFolder.replace('folders/', '')}
                    </a>
                  </Form.Item>
                </Col>
              </>
            )}
          </Fragment>
        )}
        {isNewFolder && (
          <Form>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label='Folder'>
                <Input
                  name='newFolder'
                  placeholder='Folder Name'
                  onChange={({ target }) => setNewFolder(target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout}>
                <Button style={{ marginLeft: '10px' }} onClick={submitFolder} type='primary'>
                  {' '}
                  Create{' '}
                </Button>
              </Form.Item>
            </Col>
          </Form>
        )}
      </Row>
      <Row style={{ marginTop: 30 }} />
      <Row>
        {activitiesFiles.length === 0 && (
          <Row>
            <Col span={8}>
              <Alert message={'You need to upload files first in the files tab.'} type={'info'} showIcon />
            </Col>
            <RefreshButton onClick={fetchFile} />
          </Row>
        )}
        <CustomTable
          data={files}
          defaultPageSize={10}
          fetching={fetchingFiles || fetchingActivitiesFiles}
          fetch={fetchFile || fetchActivitiesFile}
          CreateButton={() => (
            <Fragment>
              <Col span={8}>
                <FilesSelect
                  keyAtr={'_id'}
                  valueAtr={'name'}
                  placeholder='Select a File to assign'
                  style={{ width: '100%' }}
                  value={selectedFile}
                  disabled={isNewFolder}
                  onChange={(c) => setSelectedFile(c)}
                />
              </Col>
              <Col span={8}>
                <Button type={'primary'} style={{ marginLeft: '10px' }} disabled={isNewFolder} onClick={onAssign}>
                  Assign
                </Button>
              </Col>
            </Fragment>
          )}
          columns={[
            { Header: 'Name', accessor: 'name' },
            { Header: 'Size', accessor: 'size' },
            { Header: 'title', accessor: 'title' },
            {
              Header: 'actions',
              accessor: 'action',
              Cell: ({ value, original }) => (
                <Button type={'danger'} style={{ marginLeft: '10px' }} onClick={() => removeLink(original.rid)}>
                  Remove
                </Button>
              ),
            },
          ]}
        />
      </Row>
    </Fragment>
  )
}

export default Folders
